import React, { useState } from 'react';
import './App.css';
import Menu from './Menu';
import OrderManagement from './OrderManagement';
import Reports from './Reports';
import { 
  MdInventory2, 
  MdAttachMoney, 
  MdWarning, 
  MdError, 
  MdAdd, 
  MdEdit, 
  MdBarChart, 
  MdPerson,
  MdPowerSettingsNew 
} from 'react-icons/md';

// モックデータ
const mockInventoryData = [
  { id: 'INV001', name: 'スチール板材 5mm', category: '原材料', stock: 45, minStock: 20, costPrice: 12000, sellingPrice: 15000, location: '第1倉庫-A-01', status: 'normal' },
  { id: 'INV002', name: 'ボルト M8x50', category: '部品', stock: 8, minStock: 10, costPrice: 60, sellingPrice: 80, location: '第2倉庫-B-03', status: 'low' },
  { id: 'INV003', name: 'アルミニウム角材', category: '原材料', stock: 12, minStock: 15, costPrice: 2000, sellingPrice: 2500, location: '第1倉庫-A-05', status: 'low' },
  { id: 'INV004', name: '電動ドリル替刃', category: '工具', stock: 25, minStock: 10, costPrice: 950, sellingPrice: 1200, location: '第3倉庫-C-02', status: 'normal' },
  { id: 'INV005', name: '完成品 モーターケース', category: '完成品', stock: 0, minStock: 25, costPrice: 6500, sellingPrice: 8500, location: '完成品倉庫-F-01', status: 'out' },
  { id: 'INV006', name: '切削油 20L', category: '消耗品', stock: 18, minStock: 12, costPrice: 2500, sellingPrice: 3200, location: '化学品倉庫-D-01', status: 'normal' }
];

const mockTransactionData = [
  { id: 'TXN001', itemId: 'INV001', itemName: 'スチール板材 5mm', type: '入庫', quantity: 20, unitPrice: 15000, total: 300000, date: '2025-01-15', time: '10:30', operator: '田中太郎', reference: 'PO-2025-001', reason: '定期発注' },
  { id: 'TXN002', itemId: 'INV002', itemName: 'ボルト M8x50', type: '出庫', quantity: -15, unitPrice: 80, total: -1200, date: '2025-01-14', time: '16:45', operator: '佐藤花子', reference: 'WO-2025-005', reason: '製品A100製造' },
  { id: 'TXN003', itemId: 'INV003', itemName: 'アルミニウム角材', type: '調整', quantity: -3, unitPrice: 2500, total: -7500, date: '2025-01-13', time: '11:20', operator: '山田次郎', reference: 'ADJ-2025-001', reason: '棚卸調整' },
  { id: 'TXN004', itemId: 'INV005', itemName: '完成品 モーターケース', type: '入庫', quantity: 10, unitPrice: 8500, total: 85000, date: '2025-01-12', time: '14:00', operator: '鈴木一郎', reference: 'WO-2025-003', reason: '製造完成' },
  { id: 'TXN005', itemId: 'INV004', itemName: '電動ドリル替刃', type: '出庫', quantity: -5, unitPrice: 1200, total: -6000, date: '2025-01-11', time: '09:15', operator: '伊藤美咲', reference: 'SO-2025-012', reason: '顧客出荷' },
  { id: 'TXN006', itemId: 'INV006', itemName: '切削油 20L', type: '入庫', quantity: 8, unitPrice: 3200, total: 25600, date: '2025-01-10', time: '15:30', operator: '高橋健太', reference: 'PO-2025-002', reason: '補充発注' },
  { id: 'TXN007', itemId: 'INV001', itemName: 'スチール板材 5mm', type: '出庫', quantity: -12, unitPrice: 15000, total: -180000, date: '2025-01-09', time: '08:45', operator: '渡辺真由', reference: 'WO-2025-001', reason: '大型製品製造' },
  { id: 'TXN008', itemId: 'INV002', itemName: 'ボルト M8x50', type: '入庫', quantity: 100, unitPrice: 80, total: 8000, date: '2025-01-08', time: '13:15', operator: '中村雅子', reference: 'PO-2025-003', reason: '月次補充' },
];

const mockOrdersData = [
  { id: 'ORD001', type: '発注', orderNumber: 'PO-2025-001', itemName: 'スチール板材 5mm', quantity: 100, unitPrice: 15000, totalAmount: 1500000, supplier: '鋼材株式会社', customer: '', orderDate: '2025-01-15', deliveryDate: '2025-01-25', status: '処理中', notes: '定期発注分' },
  { id: 'ORD002', type: '受注', orderNumber: 'SO-2025-012', itemName: '完成品 モーターケース', quantity: 50, unitPrice: 8500, totalAmount: 425000, supplier: '', customer: 'ABC製造株式会社', orderDate: '2025-01-14', deliveryDate: '2025-02-01', status: '未処理', notes: '特急対応希望' },
  { id: 'ORD003', type: '発注', orderNumber: 'PO-2025-002', itemName: 'ボルト M8x50', quantity: 500, unitPrice: 80, totalAmount: 40000, supplier: 'ネジ専門商事', customer: '', orderDate: '2025-01-13', deliveryDate: '2025-01-20', status: '完了', notes: '' },
  { id: 'ORD004', type: '受注', orderNumber: 'SO-2025-013', itemName: '電動ドリル替刃', quantity: 30, unitPrice: 1200, totalAmount: 36000, supplier: '', customer: '工具販売株式会社', orderDate: '2025-01-12', deliveryDate: '2025-01-22', status: '処理中', notes: '' },
  { id: 'ORD005', type: '発注', orderNumber: 'PO-2025-003', itemName: 'アルミニウム角材', quantity: 50, unitPrice: 2500, totalAmount: 125000, supplier: '金属材料店', customer: '', orderDate: '2025-01-11', deliveryDate: '2025-01-21', status: '処理中', notes: '' },
  { id: 'ORD006', type: '受注', orderNumber: 'SO-2025-014', itemName: 'スチール板材 5mm', quantity: 80, unitPrice: 15000, totalAmount: 1200000, supplier: '', customer: 'XYZ工業', orderDate: '2025-01-10', deliveryDate: '2025-01-28', status: '未処理', notes: '' },
  { id: 'ORD007', type: '発注', orderNumber: 'PO-2025-004', itemName: '切削油 20L', quantity: 20, unitPrice: 3200, totalAmount: 64000, supplier: '油脂商社', customer: '', orderDate: '2025-01-09', deliveryDate: '2025-01-19', status: '完了', notes: '' },
  { id: 'ORD008', type: '受注', orderNumber: 'SO-2025-015', itemName: 'ボルト M8x50', quantity: 200, unitPrice: 80, totalAmount: 16000, supplier: '', customer: '建設会社ABC', orderDate: '2025-01-08', deliveryDate: '2025-01-25', status: '処理中', notes: '' },
];

const mockStats = {
  totalItems: 147, // 使用されていない（actualTotalItemsを使用）
  totalItemsYesterday: 105,
  totalItemsLastWeek: 100,
  totalValue: 2450000, // 使用されていない（actualTotalValueを使用）
  totalValueYesterday: 780000,
  totalValueLastWeek: 765000,
  lowStockItems: 12,
  outOfStockItems: 3,
  recentTransactions: 28
};

type ActiveTab = 'dashboard' | 'inventory' | 'transactions' | 'reports' | 'inventory-input' | 'orders' | 'receiving' | 'shipping';
type InventoryViewMode = 'quantity' | 'value';

function App() {
  const [activeTab, setActiveTab] = useState<ActiveTab>('dashboard');
  const [searchTerm, setSearchTerm] = useState('');
  const [transactionFilter, setTransactionFilter] = useState('all');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState<any>(null);
  const [inventoryViewMode, setInventoryViewMode] = useState<InventoryViewMode>('quantity');
  const [selectedYearMonth, setSelectedYearMonth] = useState('2025-01');

  // 実際の在庫データから総在庫価額と総在庫数を計算
  const actualTotalValue = mockInventoryData.reduce((sum, item) => sum + (item.stock * item.sellingPrice), 0);
  const actualTotalCostValue = mockInventoryData.reduce((sum, item) => sum + (item.stock * item.costPrice), 0);
  const actualTotalItems = mockInventoryData.reduce((sum, item) => sum + item.stock, 0);
  const lowStockItemsList = mockInventoryData.filter(item => item.stock < item.minStock && item.stock > 0);
  const outOfStockItemsList = mockInventoryData.filter(item => item.stock === 0);
  const actualLowStockItems = lowStockItemsList.length;
  const actualOutOfStockItems = outOfStockItemsList.length;

  const getStockStatusClass = (status: string) => {
    switch (status) {
      case 'low': return 'status-low';
      case 'out': return 'status-out';
      case 'normal': return 'status-normal';
      default: return 'status-normal';
    }
  };

  const getStockStatusLabel = (status: string) => {
    switch (status) {
      case 'low': return '低在庫';
      case 'out': return '在庫切れ';
      case 'normal': return '正常';
      default: return '正常';
    }
  };

  const filteredItems = mockInventoryData.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.id.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredTransactions = mockTransactionData.filter(transaction => {
    // 取引種別フィルター
    if (transactionFilter !== 'all' && transaction.type !== transactionFilter) {
      return false;
    }
    
    // 日付フィルター（選択された年月に一致するもののみ）
    const transactionYearMonth = transaction.date.substring(0, 7); // "2025-01-15" -> "2025-01"
    if (transactionYearMonth !== selectedYearMonth) {
      return false;
    }
    
    return true;
  });

  // 前月・次月への移動関数
  const handlePreviousMonth = () => {
    const [year, month] = selectedYearMonth.split('-').map(Number);
    const date = new Date(year, month - 1, 1);
    date.setMonth(date.getMonth() - 1);
    setSelectedYearMonth(`${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`);
  };

  const handleNextMonth = () => {
    const [year, month] = selectedYearMonth.split('-').map(Number);
    const date = new Date(year, month - 1, 1);
    date.setMonth(date.getMonth() + 1);
    setSelectedYearMonth(`${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`);
  };

  // 年月を表示形式に変換
  const formatYearMonth = (yearMonth: string) => {
    const [year, month] = yearMonth.split('-');
    return `${year}年${parseInt(month)}月`;
  };

  const getTransactionTypeClass = (type: string) => {
    switch (type) {
      case '入庫': return 'tx-in';
      case '出庫': return 'tx-out';
      case '調整': return 'tx-adjust';
      default: return 'tx-other';
    }
  };

  const getOrderTypeClass = (type: string) => {
    return type === '受注' ? 'order-type-sales' : 'order-type-purchase';
  };

  const getOrderStatusClass = (status: string) => {
    switch (status) {
      case '未処理': return 'status-pending';
      case '処理中': return 'status-processing';
      case '完了': return 'status-completed';
      case 'キャンセル': return 'status-cancelled';
      default: return '';
    }
  };

  return (
    <div className="App">
      <div className={`app-layout ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <Menu
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          isOpen={sidebarOpen}
          onToggle={() => setSidebarOpen(!sidebarOpen)}
        />

        <div className="app-content">
          <header className="app-header">
            <div className="header-content">
              <div className="logo-section">
                <h1>製造業在庫管理システム</h1>
              </div>
              <div className="header-stats">
                <div className="header-user">
                  <div className="user-menu-container">
                    <div className="user-info" onClick={() => setIsUserModalOpen((v) => !v)} aria-haspopup="menu" aria-expanded={isUserModalOpen}>
                      <div className="user-details">
                        <span className="user-role">システム管理者</span>
                        <span className="user-caret">{isUserModalOpen ? '▲' : '▼'}</span>
                      </div>
                    </div>
                    {isUserModalOpen && (
                      <div className="user-menu" role="menu">
                        <div className="user-menu-header">橋真弥</div>
                        <button className="user-menu-item" role="menuitem">マイページ</button>
                        <div className="user-menu-sep" />
                        <button className="user-menu-item" role="menuitem">個人設定</button>
                        <button className="user-menu-item" role="menuitem">パスワード変更</button>
                        <button className="user-menu-item" role="menuitem">メールアドレス変更</button>
                        <button className="user-menu-item" role="menuitem">ソーシャルログイン設定</button>
                        <div className="user-menu-sep" />
                        <button className="user-menu-item danger" role="menuitem" onClick={() => setIsUserModalOpen(false)}>ログアウト</button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </header>

          <main className="app-main">
            {activeTab === 'dashboard' && (
              <div className="dashboard">
                <div className="dashboard-header">
                  <h2>ダッシュボード</h2>
                </div>

                <div className="dashboard-grid">
                  {/* 左上: 統合統計カード */}
                  <div className="stats-summary-card">
                    <div className="card-header-section">
                      <h3>在庫情報</h3>
                      <span className="last-updated">最終更新: 5分前</span>
                    </div>
                    <div className="stats-compact-grid">
                      <div className="stat-compact total-items stat-compact-extended" onClick={() => setActiveTab('inventory')}>
                        <div className="stat-icon-compact"><MdInventory2 /></div>
                        <div className="stat-info-extended-horizontal">
                          <div className="stat-info" onClick={() => {
                            setActiveTab('inventory');
                            setInventoryViewMode('quantity');
                          }}>
                            <span className="stat-label">総在庫数</span>
                            <span className="stat-value-compact">{actualTotalItems}</span>
                          </div>
                          <div className="stat-comparison-horizontal">
                            <div className="comparison-item-horizontal">
                              <span className="comparison-label-horizontal">前日比</span>
                              <span className={`comparison-value-horizontal ${actualTotalItems >= mockStats.totalItemsYesterday ? 'positive' : 'negative'}`}>
                                {actualTotalItems >= mockStats.totalItemsYesterday ? '+' : '-'}
                                {actualTotalItems - mockStats.totalItemsYesterday}
                                <span className="comparison-percent">
                                  ({((actualTotalItems / mockStats.totalItemsYesterday) * 100).toFixed(1)}%)
                                </span>
                              </span>
                            </div>
                            <div className="comparison-item-horizontal">
                              <span className="comparison-label-horizontal">先週比</span>
                              <span className={`comparison-value-horizontal ${actualTotalItems >= mockStats.totalItemsLastWeek ? 'positive' : 'negative'}`}>
                                {actualTotalItems >= mockStats.totalItemsLastWeek ? '+' : '-'}
                                {actualTotalItems - mockStats.totalItemsLastWeek}
                                <span className="comparison-percent">
                                  ({((actualTotalItems / mockStats.totalItemsLastWeek) * 100).toFixed(1)}%)
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="stat-compact total-value stat-compact-extended">
                        <div className="stat-icon-compact"><MdAttachMoney /></div>
                        <div className="stat-info-extended-horizontal">
                          <div
                            className="stat-info"
                            onClick={() => {
                              setActiveTab('inventory');
                              setInventoryViewMode('value');
                            }}
                          >
                            <span className="stat-label">総在庫価額 (売価)</span>
                            <span className="stat-value-compact">¥{actualTotalValue.toLocaleString()}</span>
                          </div>
                          <div className="stat-comparison-horizontal">
                            <div className="comparison-item-horizontal">
                              <span className="comparison-label-horizontal">前日比</span>
                              <span className={`comparison-value-horizontal ${actualTotalValue >= mockStats.totalValueYesterday ? 'positive' : 'negative'}`}>
                                {actualTotalValue >= mockStats.totalValueYesterday ? '+' : '-'}
                                ¥{Math.abs(actualTotalValue - mockStats.totalValueYesterday).toLocaleString()}
                                <span className="comparison-percent">
                                  ({((actualTotalValue / mockStats.totalValueYesterday) * 100).toFixed(1)}%)
                                </span>
                              </span>
                            </div>
                            <div className="comparison-item-horizontal">
                              <span className="comparison-label-horizontal">先週比</span>
                              <span className={`comparison-value-horizontal ${actualTotalValue >= mockStats.totalValueLastWeek ? 'positive' : 'negative'}`}>
                                {actualTotalValue >= mockStats.totalValueLastWeek ? '+' : '-'}
                                ¥{Math.abs(actualTotalValue - mockStats.totalValueLastWeek).toLocaleString()}
                                <span className="comparison-percent">
                                  ({((actualTotalValue / mockStats.totalValueLastWeek) * 100).toFixed(1)}%)
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="stat-compact low-stock stat-compact-with-list">
                        <div className="stat-icon-compact" onClick={() => {
                            setActiveTab('inventory');
                            setInventoryViewMode('quantity');
                          }}><MdWarning /></div>
                        <div className="stat-info-vertical">
                          <div className="stat-header" onClick={() => {
                            setActiveTab('inventory');
                            setInventoryViewMode('quantity');
                          }}>
                            <span className="stat-label">低在庫数</span>
                            <span className="stat-value-compact">{actualLowStockItems}</span>
                          </div>
                          {lowStockItemsList.length > 0 && (
                            <div className="stat-items-list" onClick={() => {
                              setActiveTab('inventory');
                              setInventoryViewMode('quantity');
                            }}>
                              {lowStockItemsList.map((item) => (
                                <div key={item.id} className="stat-item-row">
                                  <span className="item-name">{item.name}</span>
                                  <span className="item-stock">{item.stock}/{item.minStock}</span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="stat-compact out-stock stat-compact-with-list">
                        <div className="stat-icon-compact" onClick={() => {
                            setActiveTab('inventory');
                            setInventoryViewMode('quantity');
                          }}><MdError /></div>
                        <div className="stat-info-vertical">
                          <div className="stat-header" onClick={() => {
                            setActiveTab('inventory');
                            setInventoryViewMode('quantity');
                          }}>
                            <span className="stat-label">在庫切れ数</span>
                            <span className="stat-value-compact">{actualOutOfStockItems}</span>
                          </div>
                          {outOfStockItemsList.length > 0 && (
                            <div className="stat-items-list" onClick={() => {
                              setActiveTab('inventory');
                              setInventoryViewMode('quantity');
                            }}>
                              {outOfStockItemsList.map((item) => (
                                <div key={item.id} className="stat-item-row" >
                                  <span className="item-name">{item.name}</span>
                                  <span className="item-stock">0/{item.minStock}</span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 右上: 最近の取引 */}
                  <div className="recent-transactions-card">
                    <div className="card-header-section">
                      <h3>直近の入出庫履歴</h3>
                      <button className="view-all-btn" onClick={() => setActiveTab('transactions')}>すべて表示</button>
                    </div>
                    <div className="recent-transactions-list" onClick={() => setActiveTab('transactions')}>
                      {mockTransactionData.slice(0, 5).map((transaction) => (
                        <div key={transaction.id} className="recent-tx-item">
                          <div className={`tx-type-indicator ${getTransactionTypeClass(transaction.type)}`}>
                            {transaction.type}
                          </div>
                          <div className="tx-details">
                            <div className="tx-item-name">{transaction.itemName}</div>
                            <div className="tx-meta">
                              <span className="tx-quantity">{transaction.quantity > 0 ? '+' : ''}{transaction.quantity}</span>
                              <span className="tx-time">{transaction.time}</span>
                            </div>
                          </div>
                          <div className="tx-amount">
                            {transaction.total > 0 ? '+' : ''}¥{Math.abs(transaction.total).toLocaleString()}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* 直近の受発注履歴 */}
                  <div className="recent-orders-card">
                    <div className="card-header-section">
                      <h3>直近の受発注履歴</h3>
                      <button className="view-all-btn" onClick={() => setActiveTab('orders')}>すべて表示</button>
                    </div>
                    <div className="recent-orders-list" onClick={() => setActiveTab('orders')}>
                      {mockOrdersData.map((order) => (
                        <div key={order.id} className="recent-order-item">
                          <div className="order-header-row">
                            <span className={`order-type-badge ${getOrderTypeClass(order.type)}`}>
                              {order.type}
                            </span>
                            <span className={`order-status-badge ${getOrderStatusClass(order.status)}`}>
                              {order.status}
                            </span>
                          </div>
                          <div className="order-content">
                            <div className="order-item-name">{order.itemName}</div>
                            <div className="order-details-row">
                              <span className="order-partner">
                                {order.type === '受注' ? order.customer : order.supplier}
                              </span>
                              <span className="order-quantity">{order.quantity}個</span>
                            </div>
                            <div className="order-footer-row">
                              <span className="order-date">納期: {order.deliveryDate}</span>
                              <span className="order-amount">¥{order.totalAmount.toLocaleString()}</span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                </div>
              </div>
            )}

            {activeTab === 'inventory' && (
              <div className="inventory">
                <div className="inventory-header">
                  <h2>在庫一覧</h2>
                  <div className="inventory-controls">
                    <div className="view-mode-toggle">
                      <button 
                        className={`view-mode-btn ${inventoryViewMode === 'quantity' ? 'active' : ''}`}
                        onClick={() => setInventoryViewMode('quantity')}
                        
                      >
                        総在庫数
                      </button>
                      <button 
                        className={`view-mode-btn ${inventoryViewMode === 'value' ? 'active' : ''}`}
                        onClick={() => setInventoryViewMode('value')}
                      >
                        総在庫価額
                      </button>
                    </div>
                    <input
                      type="text"
                      placeholder="商品名またはSKUで検索..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className="search-input"
                    />
                  </div>
                </div>

                <div className={`inventory-table ${inventoryViewMode === 'value' ? 'value-mode' : 'quantity-mode'}`}>
                  <div className="table-header">
                    <div className="col-sku">SKU</div>
                    <div className="col-name">商品名</div>
                    <div className="col-category">カテゴリ</div>
                    <div className="col-status">ステータス</div>
                    
                    {inventoryViewMode === 'quantity' ? (
                      <>
                        <div className="col-stock">現在在庫</div>
                        <div className="col-min-stock">最低在庫</div>
                      </>
                    ) : (
                      <>
                        <div className="col-cost-price">原価</div>
                        <div className="col-selling-price">売価</div>
                        <div className="col-cost-value">在庫原価額</div>
                        <div className="col-selling-value">在庫売価額</div>
                      </>
                    )}
                    
                    <div className="col-location">保管場所</div>
                    <div className="col-actions">操作</div>
                  </div>
                  
                  {filteredItems.map((item) => (
                    <div key={item.id} className="table-row">
                      <div className="col-sku">{item.id}</div>
                      <div className="col-name">{item.name}</div>
                      <div className="col-category">{item.category}</div>
                      <div className="col-status">
                        <span className={`status-badge ${getStockStatusClass(item.status)}`}>
                          {getStockStatusLabel(item.status)}
                        </span>
                      </div>
                      
                      {inventoryViewMode === 'quantity' ? (
                        <>
                          <div className={`col-stock ${item.stock < item.minStock ? 'low-stock-alert' : ''}`}>
                            {item.stock < item.minStock && <MdWarning className="stock-warning-icon" />}
                            <span className="stock-value">{item.stock}</span>
                          </div>
                          <div className="col-min-stock">
                            <span className="min-stock-value">{item.minStock}</span>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="col-cost-price">¥{item.costPrice.toLocaleString()}</div>
                          <div className="col-selling-price">¥{item.sellingPrice.toLocaleString()}</div>
                          <div className="col-cost-value">
                            <span className="value-amount">¥{(item.stock * item.costPrice).toLocaleString()}</span>
                          </div>
                          <div className="col-selling-value">
                            <span className="value-amount">¥{(item.stock * item.sellingPrice).toLocaleString()}</span>
                          </div>
                        </>
                      )}
                      
                      <div className="col-location">{item.location}</div>
                      <div className="col-actions">
                        <button 
                          className="btn-icon btn-edit"
                          onClick={() => {
                            setEditingItem(item);
                            setActiveTab('inventory-input');
                          }}
                          title="編集"
                        >
                          <MdEdit />
                        </button>
                        <button 
                          className="btn-icon btn-history" 
                          onClick={() => {
                            setActiveTab('transactions');
                            setEditingItem(item);
                          }}
                          title="履歴"
                        >
                          <MdBarChart />
                        </button>
                      </div>
                    </div>
                  ))}
                  
                  {/* 合計行 */}
                  <div className="table-row table-total-row">
                    <div className="col-sku"></div>
                    <div className="col-name total-label">合計</div>
                    <div className="col-category"></div>
                    <div className="col-status"></div>
                    
                    {inventoryViewMode === 'quantity' ? (
                      <>
                        <div className="col-stock">
                          <span className="total-value">
                            {filteredItems.reduce((sum, item) => sum + item.stock, 0)}
                          </span>
                        </div>
                        <div className="col-min-stock">
                          <span className="total-value">
                            {filteredItems.reduce((sum, item) => sum + item.minStock, 0)}
                          </span>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="col-cost-price"></div>
                        <div className="col-selling-price"></div>
                        <div className="col-cost-value">
                          <span className="total-value">
                            ¥{filteredItems.reduce((sum, item) => sum + (item.stock * item.costPrice), 0).toLocaleString()}
                          </span>
                        </div>
                        <div className="col-selling-value">
                          <span className="total-value">
                            ¥{filteredItems.reduce((sum, item) => sum + (item.stock * item.sellingPrice), 0).toLocaleString()}
                          </span>
                        </div>
                      </>
                    )}
                    
                    <div className="col-location"></div>
                    <div className="col-actions"></div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'transactions' && (
              <div className="transactions">
                <div className="transactions-header">
                  <div className="header-left-group">
                    <h2>取引履歴</h2>
                    <div className="month-navigation">
                      <button className="month-nav-btn" onClick={handlePreviousMonth}>
                        &lt;
                      </button>
                      <span className="month-display">{formatYearMonth(selectedYearMonth)}</span>
                      <button className="month-nav-btn" onClick={handleNextMonth}>
                        &gt;
                      </button>
                    </div>
                  </div>
                  <div className="transaction-controls">
                    <select
                      value={transactionFilter}
                      onChange={(e) => setTransactionFilter(e.target.value)}
                      className="filter-select"
                    >
                      <option value="all">全ての取引</option>
                      <option value="入庫">入庫</option>
                      <option value="出庫">出庫</option>
                      <option value="調整">調整</option>
                    </select>
                    <button className="export-btn">CSV出力</button>
                  </div>
                </div>

                <div className="transactions-summary">
                  <div className="summary-card">
                    <span className="summary-label">{formatYearMonth(selectedYearMonth)}の取引数</span>
                    <span className="summary-value">{filteredTransactions.length}</span>
                  </div>
                  <div className="summary-card">
                    <span className="summary-label">入庫取引</span>
                    <span className="summary-value">{filteredTransactions.filter(t => t.type === '入庫').length}</span>
                  </div>
                  <div className="summary-card">
                    <span className="summary-label">出庫取引</span>
                    <span className="summary-value">{filteredTransactions.filter(t => t.type === '出庫').length}</span>
                  </div>
                </div>

                <div className="transactions-table">
                  <div className="table-header">
                    <div className="col-date">日時</div>
                    <div className="col-type">種別</div>
                    <div className="col-item">アイテム</div>
                    <div className="col-quantity">数量</div>
                    <div className="col-total">金額</div>
                    <div className="col-operator">担当者</div>
                    <div className="col-reason">理由</div>
                  </div>
                  {filteredTransactions.map((transaction) => (
                    <div key={transaction.id} className="table-row">
                      <div className="col-date">
                        <div className="date">{transaction.date}</div>
                        <div className="time">{transaction.time}</div>
                      </div>
                      <div className="col-type">
                        <span className={`type-badge ${getTransactionTypeClass(transaction.type)}`}>
                          {transaction.type}
                        </span>
                      </div>
                      <div className="col-item">
                        <div className="item-name">{transaction.itemName}</div>
                        <div className="item-id">{transaction.itemId}</div>
                      </div>
                      <div className="col-quantity">
                        <span className={transaction.quantity > 0 ? 'qty-positive' : 'qty-negative'}>
                          {transaction.quantity > 0 ? '+' : ''}{transaction.quantity}
                        </span>
                      </div>
                      <div className="col-total">
                        <span className={transaction.total > 0 ? 'amount-positive' : 'amount-negative'}>
                          ¥{Math.abs(transaction.total).toLocaleString()}
                        </span>
                      </div>
                      <div className="col-operator">{transaction.operator}</div>
                      <div className="col-reason">{transaction.reason}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {activeTab === 'reports' && (
              <Reports />
            )}

            {activeTab === 'inventory-input' && (
              <div className="inventory">
                <div className="inventory-header">
                  <h2>{editingItem ? '在庫編集' : '在庫入力'}</h2>
                </div>
                <div className="input-form">
                  <div className="form-section">
                    <h3>基本情報</h3>
                    <div className="form-grid">
                      <div className="form-group">
                        <label>商品名 <span className="required">*</span></label>
                        <input 
                          type="text" 
                          className="form-input" 
                          placeholder="商品名を入力" 
                          defaultValue={editingItem?.name || ''}
                        />
                      </div>
                      <div className="form-group">
                        <label>SKU <span className="required">*</span></label>
                        <input 
                          type="text" 
                          className="form-input" 
                          placeholder="INV000" 
                          defaultValue={editingItem?.id || ''}
                        />
                      </div>
                      <div className="form-group">
                        <label>カテゴリ <span className="required">*</span></label>
                        <select className="form-input" defaultValue={editingItem?.category || ''}>
                          <option value="">選択してください</option>
                          <option value="原材料">原材料</option>
                          <option value="部品">部品</option>
                          <option value="完成品">完成品</option>
                          <option value="工具">工具</option>
                          <option value="消耗品">消耗品</option>
                        </select>
                      </div>
                      <div className="form-group">
                        <label>保管場所 <span className="required">*</span></label>
                        <input 
                          type="text" 
                          className="form-input" 
                          placeholder="第1倉庫-A-01" 
                          defaultValue={editingItem?.location || ''}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-section">
                    <h3>在庫情報</h3>
                    <div className="form-grid">
                      <div className="form-group">
                        <label>現在在庫数 <span className="required">*</span></label>
                        <input 
                          type="number" 
                          className="form-input" 
                          placeholder="0" 
                          min="0" 
                          defaultValue={editingItem?.stock || ''}
                        />
                      </div>
                      <div className="form-group">
                        <label>最低在庫数 <span className="required">*</span></label>
                        <input 
                          type="number" 
                          className="form-input" 
                          placeholder="0" 
                          min="0" 
                          defaultValue={editingItem?.minStock || ''}
                        />
                      </div>
                      <div className="form-group">
                        <label>原価 (¥) <span className="required">*</span></label>
                        <input 
                          type="number" 
                          className="form-input" 
                          placeholder="0" 
                          min="0" 
                          defaultValue={editingItem?.costPrice || ''}
                        />
                      </div>
                      <div className="form-group">
                        <label>売価 (¥) <span className="required">*</span></label>
                        <input 
                          type="number" 
                          className="form-input" 
                          placeholder="0" 
                          min="0" 
                          defaultValue={editingItem?.sellingPrice || ''}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-actions">
                    <button className="btn-secondary" onClick={() => {
                      setEditingItem(null);
                      setActiveTab('inventory');
                    }}>キャンセル</button>
                    <button className="btn-primary">{editingItem ? '更新' : '登録'}</button>
                  </div>
                </div>
              </div>

              
            )}

            {activeTab === 'orders' && (
              <OrderManagement />
            )}

            {activeTab === 'receiving' && (
              <div className="inventory">
                <div className="inventory-header">
                  <h2>入荷入力</h2>
                </div>
                <div className="input-form">
                  <div className="form-section">
                    <h3>入荷情報</h3>
                    <div className="form-grid">
                      <div className="form-group">
                        <label>商品名 <span className="required">*</span></label>
                        <select className="form-input">
                          <option value="">選択してください</option>
                          {mockInventoryData.map(item => (
                            <option key={item.id} value={item.id}>{item.name}</option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label>入荷数量 <span className="required">*</span></label>
                        <input 
                          type="number" 
                          className="form-input" 
                          placeholder="0" 
                          min="1"
                        />
                      </div>
                      <div className="form-group">
                        <label>単価 (¥)</label>
                        <input 
                          type="number" 
                          className="form-input" 
                          placeholder="0" 
                          min="0"
                        />
                      </div>
                      <div className="form-group">
                        <label>入荷日</label>
                        <input 
                          type="date" 
                          className="form-input"
                        />
                      </div>
                      <div className="form-group">
                        <label>参照番号</label>
                        <input 
                          type="text" 
                          className="form-input" 
                          placeholder="PO-2025-001"
                        />
                      </div>
                      <div className="form-group">
                        <label>担当者</label>
                        <input 
                          type="text" 
                          className="form-input" 
                          placeholder="担当者名"
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label>備考</label>
                      <textarea 
                        className="form-input" 
                        placeholder="備考・メモ"
                        rows={3}
                      />
                    </div>
                  </div>

                  <div className="form-actions">
                    <button className="btn-secondary" onClick={() => setActiveTab('dashboard')}>キャンセル</button>
                    <button className="btn-primary">入荷登録</button>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'shipping' && (
              <div className="inventory">
                <div className="inventory-header">
                  <h2>出荷入力</h2>
                </div>
                <div className="input-form">
                  <div className="form-section">
                    <h3>出荷情報</h3>
                    <div className="form-grid">
                      <div className="form-group">
                        <label>商品名 <span className="required">*</span></label>
                        <select className="form-input">
                          <option value="">選択してください</option>
                          {mockInventoryData.map(item => (
                            <option key={item.id} value={item.id}>{item.name}</option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label>出荷数量 <span className="required">*</span></label>
                        <input 
                          type="number" 
                          className="form-input" 
                          placeholder="0" 
                          min="1"
                        />
                      </div>
                      <div className="form-group">
                        <label>出荷先</label>
                        <input 
                          type="text" 
                          className="form-input" 
                          placeholder="顧客名・部門名"
                        />
                      </div>
                      <div className="form-group">
                        <label>出荷日</label>
                        <input 
                          type="date" 
                          className="form-input"
                        />
                      </div>
                      <div className="form-group">
                        <label>参照番号</label>
                        <input 
                          type="text" 
                          className="form-input" 
                          placeholder="SO-2025-001"
                        />
                      </div>
                      <div className="form-group">
                        <label>担当者</label>
                        <input 
                          type="text" 
                          className="form-input" 
                          placeholder="担当者名"
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label>備考</label>
                      <textarea 
                        className="form-input" 
                        placeholder="備考・メモ"
                        rows={3}
                      />
                    </div>
                  </div>

                  <div className="form-actions">
                    <button className="btn-secondary" onClick={() => setActiveTab('dashboard')}>キャンセル</button>
                    <button className="btn-primary">出荷登録</button>
                  </div>
                </div>
              </div>
            )}
          </main>

          {/* The side-panel for user info is removed as per the edit hint. */}
        </div>
      </div>
    </div>
  );
}

export default App;